import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit, OnDestroy {

  type: string = '';
  title: string = '';
  desc: string = '';
  private sub?: Subscription;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const snapshot = this.route.snapshot;
    this.type = snapshot.paramMap.get('type') ?? '';
    const queryParams = snapshot.queryParams;

    if (queryParams.error === 'access_denied') {
      this.type = '403';
    }

    this.sub = this.route.data.subscribe(data => {
      if (this.type !== '403') {
        this.type = data.type ?? this.type;
        this.title = data.title ?? this.title;
        this.desc = data.desc ?? this.desc;
      }
    });

    const errorTypes: Record<string, { title: string; desc: string }> = {
      '403': {
        title: 'Access Denied',
        desc: 'You do not have permission to access this page.<br>Please contact your administrator if you believe this is an error.'
      },
      '404': {
        title: 'Page Not Found',
        desc: 'Oopps!! The page you were looking for doesn\'t exist.'
      },
      '500': {
        title: 'Internal server error',
        desc: 'Oopps!! There was an error. Please try again later.'
      }
    };

    const fallback = {
      title: 'Something went wrong',
      desc: 'Looks like something went wrong.<br>We\'re working on it.'
    };

    const errorContent = errorTypes[this.type] ?? fallback;
    this.title ||= errorContent.title;
    this.desc ||= errorContent.desc;
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
